module.exports = __webpack_public_path__ + "04_mole.17f91e95.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer2/04_mole.png
// module id = 2ALF
// module chunks = 0